import { type FC } from "react";

import { AudioPlayer } from "@styled/audio_player";
import { TranscriptBody } from "@styled/transcript_sheet";

// Mirrors PageViewer's divided layout: the (optional) audio player, the
// verbatim Original and the cleaned Transcript, side by side, read the same
// way as on the Dictation & notes tab. Dictation-notes documents have no
// audio, so the player is omitted. Rendered as a fragment so the parent
// <Pane> supplies the flex + dividers + full-height frame.
export const AudioViewer: FC<{
  audioUrl?: string | null;
  duration?: number | null;
  rawText?: string | null;
  cleanedHtml?: string | null;
}> = ({ audioUrl, duration, rawText, cleanedHtml }) => (
  <>
    {audioUrl && (
      <div className="flex h-full flex-1 items-center justify-center p-4">
        <AudioPlayer src={audioUrl} duration={duration} />
      </div>
    )}
    <div className="flex h-full flex-1 flex-col gap-4 overflow-y-scroll p-4">
      <strong>Original</strong>
      <TranscriptBody text={rawText ?? ""} />
    </div>
    <div className="flex h-full flex-1 flex-col gap-4 overflow-y-scroll p-4">
      <strong>Transcript</strong>
      {cleanedHtml && <TranscriptBody html={cleanedHtml} />}
    </div>
  </>
);
